export default __webpack_public_path__ + "static/media/J_Scott_Rumptz_Resume.52ab6178.pdf";